// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Nh1_","footer":"ReportModalFilter_footer__3e7DT"};